import './TelegramChooseChatSheet.sass';

import React, { FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { imActions, imTelegramSelector } from '$store/im';
import { RootState } from '$store/rootReducer';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { Loader } from '$shared/components';
import { Button, List, ListItem, SelectList } from '$uikit';
import { toastActions } from '$store/toast';
import { useTranslator } from '$hooks';
import { IcAdd28, IcPlusCircle28 } from '$assets';
import { telegramActions } from '$store/telegram';

const HOW_ADD_CHANNEL =
  'https://wiki.ton.place/dlya-sozdatelei-kontenta/telegram-bot/kak-dobavit-bota-v-telegram-kanal';

const TelegramChooseChatSheetInner: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { isChatsLoading, chats, chatIds, chooseChatTelegramSheetType } =
    useSelector(imTelegramSelector);

  const handleClose = useCallback(() => {
    dispatch(imActions.setChooseChatTelegramSheetVisible(false));
  }, []);

  const handleSend = useCallback(() => {
    if (chatIds.length) {
      if (chooseChatTelegramSheetType === 'connect') {
        dispatch(telegramActions.connectChannel(chatIds[0]));
      } else {
        dispatch(imActions.createTelegramInvoice());
      }
    } else {
      dispatch(toastActions.setToastFail(t('tg_bot_toast_error_empty_choose')));
    }
  }, [chatIds]);

  useEffect(() => {
    dispatch(imActions.telegramGetChats());
  }, []);

  return (
    <BottomSheet
      className="TelegramChooseChatSheet"
      title={t('tg_bot_title')}
      onClose={handleClose}
    >
      {isChatsLoading ? (
        <Loader isWrapped />
      ) : (
        <div className="TelegramChooseChatSheet__content">
          <SelectList
            description={
              chooseChatTelegramSheetType === 'connect'
                ? t('tg_bot_choose_connect_desc')
                : t('tg_bot_choose_chat_desc')
            }
            value={chatIds}
            multiple={chooseChatTelegramSheetType !== 'connect'}
            options={chats.map((chat) => ({
              label: chat.title,
              value: chat.chatId,
            }))}
            onChange={(value) => dispatch(imActions.setTelegramChatIds(value))}
          />
          <List>
            <ListItem leftIcon={<IcPlusCircle28 />} href={HOW_ADD_CHANNEL}>
              {t('tg_bot_add_chat_button')}
            </ListItem>
          </List>
          <Button onClick={handleSend}>
            {chooseChatTelegramSheetType === 'connect'
              ? 'Подключить'
              : chatIds.length
              ? t('tg_bot_send_post_button_with_number', {
                  count: chatIds.length,
                })
              : t('tg_bot_send_post_button')}
          </Button>
        </div>
      )}
    </BottomSheet>
  );
};

export const TelegramChooseChatSheet: FC = () => {
  const isSheetVisible = useSelector(
    (state) => imTelegramSelector(state as RootState).isChooseChatTelegramSheetVisible,
  );
  if (!isSheetVisible) {
    return null;
  }

  return <TelegramChooseChatSheetInner />;
};
